// extracted by mini-css-extract-plugin
export default {"imageContent":"jp-z","modal":"kp-z"};